import React, { useContext, useEffect } from 'react';
import './QuestionnairePage.css';
import { IonContent, IonPage, IonHeader, IonToolbar, IonTitle, IonItem, IonButtons, IonBackButton, IonButton, IonIcon, useIonViewWillEnter, IonToggle, IonLabel } from '@ionic/react';
import { Page as pageModel, Section } from '../models/questionnaire.model';
import PHQSection from '../components/questionnaire/PHQSection';
import { AppContext } from '../context/app.context';
import FlipMove from "react-flip-move";
import PHQConditions from '../components/questionnaire/PHQConditions/PHQConditions';
import Footer from 'layout/footer';
import { addCircle, eyeOutline } from 'ionicons/icons';
import { createSection, searchSections } from 'misc/phqHTTP';
import { HttpStatusCodeEnum } from 'models/http-status-code.enum';
import { QuestionnaireActionTypes } from 'reducers/questionnaire.reducer';
import { useHistory, useParams } from 'react-router';
interface ContainerProps {
  page: pageModel
}

const QuestionnairePage: React.FC<ContainerProps> = () => {

  const history = useHistory();
  const { pageId } = useParams<{pageId: string}>();
  const { helpMode, setHelpMode } = useContext(AppContext);
  const { questionnaire, previewPHQ, updateQuestionnaire, setIsLoading } = useContext(AppContext);

  const addSection = () => {
    const section = new Section();
    section.PageID = questionnaire.PageSelected.PageID;
    section.Cols = 1;
    section.Priority = ((questionnaire?.PageSelected?.Sections?.length || 0) + 1) * 10;

    setIsLoading(true);
    createSection(section)
      .then(res => {
          if (res.status === HttpStatusCodeEnum.CREATED) {
              const createdSection = res.data.result as Section;
              createdSection.EditSection = true;
              updateQuestionnaire(QuestionnaireActionTypes.NEW_SECTION, createdSection);
              setTimeout(() => {
                  const sections = document.querySelectorAll(".section-card");
                  if(sections && sections.length > 5) {
                      sections[sections.length - 1].scrollIntoView({behavior: 'smooth'});
                  }
              }, 300)
          }
      })
      .finally(() => setIsLoading(false))
  }

  useIonViewWillEnter(() => {
    setIsLoading(true);
    searchSections({pageId})
    .then(res => {
        const sections = res.data.result;
        if(sections.length === 1) {
            //expand first section on load 
            sections[0].EditSection = true;
        }
        sections.length > 0
            ? updateQuestionnaire(QuestionnaireActionTypes.SET_SECTIONS, sections) 
            : addSection();
    })
    .finally(() => setIsLoading(false))
  })

  const onMappingChange = (e:any) => {
    const val = !!e.detail.checked; 
    setHelpMode(val);
  }

  useEffect(() => {
      // hack to get around missing data in context on page reload
      if(!questionnaire.PhqSelected) {
        history.push('/home')
      }
  }, [questionnaire.PhqSelected, history])

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonTitle>{questionnaire?.PageSelected?.Name}</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonItem lines='none'>
              <IonButtons slot='start'>
                  <IonBackButton defaultHref="/phqpage" />
              </IonButtons>
              <IonButtons slot="end">
                  <IonItem lines="none">
                    <IonLabel color="primary">
                      <b>Mapping</b>
                    </IonLabel>
                    <IonToggle style={{height: '28px'}} checked={helpMode} onIonChange={onMappingChange} />
                  </IonItem>
                  <IonButton disabled={questionnaire?.ViewMode} fill="clear" onClick={addSection}>
                      <b>New Section</b>
                      <IonIcon icon={addCircle} />
                  </IonButton>
                  <IonButton fill="clear" onClick={() => { previewPHQ(questionnaire.PhqSelected?.PHQID) }}>
                      <strong>Preview</strong>
                      <IonIcon icon={eyeOutline} />
                  </IonButton>
              </IonButtons>
          </IonItem>
        </IonToolbar>
      </IonHeader>
      <IonContent scrollY={true}>
        <FlipMove>
          {!questionnaire?.ConditionalLogicMode && (<div>
            <PHQSection createSection={addSection}></PHQSection>
          </div>)}
          {questionnaire?.ConditionalLogicMode && (<div>
            <PHQConditions></PHQConditions>
          </div>)}

        </FlipMove>

      </IonContent>
      <Footer />
    </IonPage>
  );

};

export default QuestionnairePage;